<template>
  <v-progress-linear
    class="app-loading"
    color="primary"
    height="5"
    v-show="visible"
    :indeterminate="true"
  ></v-progress-linear>
</template>

<script>
import loading from "./";
export default {
  data() {
    return {
      visible: false
    };
  },
  methods: {
    hide() {
      this.visible = false;
    },
    show() {
      this.visible = true;
    }
  },
  beforeMount() {
    loading.EventBus.$on("show", () => {
      this.show();
    });

    loading.EventBus.$on("hide", () => {
      this.hide();
    });
  }
};
</script>

<style scoped>
.app-loading {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  margin: 0;
}
</style>